module.exports = __webpack_public_path__ + "static/media/scheme-categories-ro.da7f86a7.svg";